import { useQuery } from '@tanstack/react-query';
import { Group, Member, page } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../lib/api';
import { t } from '../../lib/i18n';
import { useCapabilitiesQuery } from '../../lib/session';

const GroupList = z.array(Group);
const MemberPage = page(Member);

export const reportsKey = ['reports'] as const;

/** The organisation's time zone, used for "today" and for times that carry no site of their own. */
export function useTenantZone(): string {
  return useCapabilitiesQuery().data?.tenant?.timeZone ?? 'Europe/London';
}

export function useActiveGroups() {
  return useQuery({ queryKey: [...reportsKey, 'groups'], queryFn: () => api.get('/groups', { query: { status: 'active' }, schema: GroupList }) });
}

/** Current members of one group, to pick a person from. */
export function useGroupMembers(groupId: string) {
  return useQuery({
    queryKey: [...reportsKey, 'members', groupId],
    enabled: groupId !== '',
    queryFn: () => api.get('/members', { query: { groupId, status: 'current', pageSize: 200 }, schema: MemberPage }),
  });
}

/** "7 h 30 min", "45 min". */
export function formatDuration(minutes: number): string {
  const m = Math.max(0, Math.round(minutes));
  const h = Math.floor(m / 60);
  return h === 0 ? t('rpt.duration.minutes', { m }) : t('rpt.duration.hm', { h, m: m % 60 });
}
